module.exports = __webpack_public_path__ + "img/menu-icon-1.ab60052d.webp";